// NOTICE: KAPTION-INTEGRATION
// security-center.UI.2 — Settings › Security, a hub with one sub-page per
// section. Admin only; the layout renders nothing unless the
// KAPTION_SECURITY_CENTER flag and the security_center permission are on.
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import KaptionSecurityLayout from './KaptionSecurityLayout.vue';
import OverviewPage from './pages/OverviewPage.vue';
import TwoStepPage from './pages/TwoStepPage.vue';
import SsoPage from './pages/SsoPage.vue';
import DomainsPage from './pages/DomainsPage.vue';
import UsersPage from './pages/UsersPage.vue';
import SessionsPage from './pages/SessionsPage.vue';
import ActivityPage from './pages/ActivityPage.vue';

const meta = { permissions: ['administrator'] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/kaption-security'),
      component: SettingsWrapper,
      props: { keepAlive: false },
      children: [
        {
          path: '',
          component: KaptionSecurityLayout,
          meta,
          children: [
            {
              path: '',
              name: 'settings_kaption_security',
              component: OverviewPage,
              meta,
            },
            {
              path: 'two-step',
              name: 'settings_kaption_security_two_step',
              component: TwoStepPage,
              meta,
            },
            {
              path: 'sso',
              name: 'settings_kaption_security_sso',
              component: SsoPage,
              meta,
            },
            {
              path: 'domains',
              name: 'settings_kaption_security_domains',
              component: DomainsPage,
              meta,
            },
            {
              path: 'users',
              name: 'settings_kaption_security_users',
              component: UsersPage,
              meta,
            },
            {
              path: 'sessions',
              name: 'settings_kaption_security_sessions',
              component: SessionsPage,
              meta,
            },
            {
              path: 'activity',
              name: 'settings_kaption_security_activity',
              component: ActivityPage,
              meta,
            },
          ],
        },
      ],
    },
  ],
};
